// extracted by mini-css-extract-plugin
export default {"content_dt":"Guara_content_dt__DKcn9","content_dtfilmes":"Guara_content_dtfilmes__wHQGe","wrapper":"Guara_wrapper__DuFHt"};